import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AfDetailModule, AfRowItemModule } from "@pattonair/auction-framework";
import { MfDialogModule } from "@pattonair/material-framework";
import { AucAuctionListComponent } from "./auction.list.component";

@NgModule({
  declarations: [
    AucAuctionListComponent,
  ],
  exports: [
    AucAuctionListComponent,
  ],
  imports: [
    BrowserModule,
    AfRowItemModule,
    AfDetailModule,
    MfDialogModule,
  ]
})
export class AucAuctionListModule { }